import { makeVar } from "@apollo/client";

export const isLoggedInReactive = makeVar(false);
